/**
 * The api-crm error codes a screen does something about, kept in step with the constants of the
 * same names in api-crm.php.
 *
 * Only the ones a caller *handles* belong here. A code that just picks different wording for the
 * same danger toast is not worth mirroring — the message is already in the response.
 */

// ERROR_DEAL_PROJECT_CASCADE — the deal's quotes would move with the project, and the caller has
// to say it means that.
export const CRM_ERROR_PROJECT_CASCADE = 30;

// ERROR_REQUIRED_WORK — an automation asked for something before the deal moves on by hand. The
// caller opens the required-work dialog rather than passing the message through as a toast.
export const CRM_ERROR_REQUIRED_WORK = 33;

// ERROR_STAGE_SEGMENT_CASCADE — a lane is moving to another stretch of the lifecycle, and deals
// standing in it whose quotes do not reach there will be derived out. The caller confirms.
export const CRM_ERROR_STAGE_SEGMENT_CASCADE = 34;

// ERROR_DEAL_LOST_REASON — unlinking the deal's last quote in play would lose it. The caller asks
// why in the Lost dialog and resends with `lost_reason`.
export const CRM_ERROR_DEAL_LOST_REASON = 35;
